module.exports = __webpack_public_path__ + "img/nonwood_en.d4f94888.svg";